import { logger } from '@adornis/base/logging.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { Conversation } from '../conversation.js';
import { Exam } from '../exam.js';

export const claimGuestConversationMutation = registerMutation({
  operationName: 'claimGuestConversation',
  type: () => Boolean,
  params: [
    { name: 'conversationId', type: () => String },
    { name: 'userId', type: () => String },
  ],
  resolve: (conversationId: string, userId: string) => async () => {
    const normalizedConversationId = String(conversationId || '')
      .trim()
      .replace(/^"(.+)"$/, '$1')
      .replace(/^'(.+)'$/, '$1');

    if (!normalizedConversationId) {
      throw new Error('Conversation-ID ist leer.');
    }

    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    const resolvedUserId = currentUser?._id || userId;
    if (!resolvedUserId) {
      throw new Error('Kein eingeloggter User für das Claiming gefunden.');
    }

    logger.info({ normalizedConversationId, collectionName: Conversation._collectionName }, 'Backend search for chat in collection');

    const rawConversationCollection = await getRawCollection(Conversation._collectionName);
    const rawExamCollection = await getRawCollection(Exam._collectionName);

    const conversation = await rawConversationCollection.findOne({
      $or: [{ _id: normalizedConversationId }, { id: normalizedConversationId }],
    } as any);

    if (!conversation) {
      logger.error(
        { normalizedConversationId, collectionName: Conversation._collectionName },
        'Conversation not found in collection',
      );
      throw new Error('Conversation nicht gefunden.');
    }

    await rawConversationCollection.updateOne({ _id: conversation._id }, { $set: { userID: resolvedUserId } });

    if (conversation.examId) {
      await rawExamCollection.updateOne(
        {
          _id: conversation.examId,
          $or: [{ userID: null }, { userID: { $exists: false } }, { userID: conversation.userID }],
        },
        { $set: { userID: resolvedUserId } },
      );
    }

    logger.info(`✅ Update in der rohen DB erfolgreich ausgeführt.`);
    return true;
  },
});
